import { Form, Space } from "antd";
import {
  HeaderOverview,
  IRenderStackedBarChart,
  RenderStackedBarChart,
} from "components";
import {
  ErrorDashboard,
  LoadingDashboard,
  NoDataDashboard,
  WrapperBG,
  checkData,
} from "pages/overview";
import { useOverview } from "providers/overview";
import { useTranslation } from "react-i18next";
import { useGetDashBoardComplaintGraphSettingType } from "service/dashboard/central/recommrnt-feed-back";

const dataKeyY = [
  { color: "#F52A53", key: "cancel" },
  { color: "#8EC641", key: "success" },
  { color: "#939498", key: "acknowledge" },
  { color: "#F8931D", key: "pending" },
];

const VolumeComplaint = () => {
  const { t } = useTranslation();
  const { findDate, property } = useOverview();

  const volumeComplaintsDate = Form.useWatch("volumeComplaintsDate");
  const date = findDate(volumeComplaintsDate);

  const { data, isFetching, isError, error } =
    useGetDashBoardComplaintGraphSettingType({
      ...date,
      property,
    });

  if (isFetching) {
    return (
      <WrapperBG>
        <LoadingDashboard loading={isFetching}>
          <HeaderOverview
            title={t("volume-complaints")}
            name="volumeComplaintsDate"
          />
          <div className="h-[300px]"></div>
          <div className="px-5 mt-3">
            <Space size="large">
              <span>{t("status")} : </span>
              <DotColor color="#F8931D" text={t("pending")} />
              <DotColor color="#939498" text={t("acknowledge")} />
              <DotColor color="#8EC641" text={t("success")} />
              <DotColor color="#F52A53" text={t("cancel")} />
            </Space>
          </div>
        </LoadingDashboard>
      </WrapperBG>
    );
  }

  const findData = checkData(data);

  const getName =
    findData?.map((item) => {
      return {
        name:
          item.category === "APPEAL"
            ? t("complaint")
            : item.category === "FEEDBACK"
            ? t("feedback")
            : item.category === "SUGGEST"
            ? t("suggest")
            : "",
        pending: item.status.pending,
        acknowledge: item.status.acknowledge,
        success: item.status.success,
        cancel: item.status.cancel,
      };
    }) || [];

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-5 rounded-app w-full shadow-lg">
          <p className="label">{label}</p>

          {payload.map((item: any) => {
            return (
              <div style={{ color: item.fill }} >  
                {t(item.name) + " : " + item.value}
              </div>
            );
          })}
        </div>
      );
    }

    return null;
  };

  const dataStackedBar: IRenderStackedBarChart = {
    data: getName,
    dataKeyX: "name",
    dataKeyY: dataKeyY,
    Content: CustomTooltip,
  };

  return (
    <WrapperBG>
      <HeaderOverview
        title={t("volume-complaints")}
        name="volumeComplaintsDate"
      />
      {isError ? (
        <ErrorDashboard error={error} height="300px" />
      ) : !findData ? (
        <NoDataDashboard height="300px" />
      ) : (
        <RenderStackedBarChart {...dataStackedBar} />
      )}
      <div className="px-5 mt-3">
        <Space size="large">
          <span>{t("status")} : </span>
          <DotColor color="#F8931D" text={t("pending")} />
          <DotColor color="#939498" text={t("acknowledge")} />
          <DotColor color="#8EC641" text={t("success")} />
          <DotColor color="#F52A53" text={t("cancel")} />
        </Space>
      </div>
    </WrapperBG>
  );
};

const DotColor = ({ color, text }: { color: string; text: string }) => {
  return (
    <div className="flex flex-row center">
      <div
        className="w-[10px] h-[10px] rounded-full mr-1"
        style={{ backgroundColor: color }}
      ></div>
      <span>{text}</span>
    </div>
  );
};

export default VolumeComplaint;
